import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import colors from '../../styles/colors';
import * as Price from '../../util/Price';

const TableContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 7px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: grey;
    border-radius: 10px;
  }
  padding-bottom:20px;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: column;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
`;
const Heading = styled.div`
  display: flex;
  justify-content: ${(props) => props.justify || 'space-between'};
  align-items: center;
  width: 100%;
  font-size: 1.8rem;
  border-right: 1px solid ${colors.grey5};
  @media screen and (max-width: 450px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`;

// const TableItem = styled.div`
//   display: flex;
//   font-size: 1.2rem;
//   padding: 15px 20px;
//   align-items: center;
//   justify-content: space-between;
//   border-top: 1px solid ${colors.grey6};
//   width: 100%;
//   box-sizing: border-box;
//   cursor: ${(props) => (props.onClick ? "pointer" : null)};
//   transition: all 0.2s;

//   &:hover {
//     background: ${(props) =>
//       props.onClick ? "rgba(211, 211, 211, 0.1)" : null};
//   }
// `;

const Row = styled.div`
  display: grid;
  grid-template-columns: 0.25fr 1fr 1fr;
  grid-template-rows: repeat(auto-fit, auto);
  background: ${(props) => props.background || colors.white};
  justify-content: center;
  position: relative;
  align-items: center;
  position: ${(props) => (props.sticky === '1' ? 'sticky' : null)};
  top: ${(props) => (props.sticky === '1' ? '0' : null)};
  z-index: ${(props) => (props.sticky === '1' ? '5' : null)};
  @media (max-width: 450px) {
    grid-template-columns: 0.4fr 1fr 1fr;
  }
`;

const HeadText = styled.div`
  color: ${colors.grey1};
  font-size: 1.4rem;
  font-weight: 500;
`;

const HeadingText = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.grey3};
  font-size: 1.4rem;
  font-weight: 400;
  height: 40px;
  padding: 10px;
  justify-content: ${(props) => props.justify || 'center'};
  width: 100%;
  @media screen and (max-width: 991px) {
    height: 40px;
    justify-content: flex-start;
  }
`;

const Column = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  height: 40px;
  align-items: ${(props) => props.align || 'center'};
  justify-content: ${(props) => props.justify || 'center'};
  border: 1px solid ${colors.grey5};
`;

const HeaderText = styled.div`
  font-size: 1.4rem;
  color: ${colors.grey3};
`;

const CheckBox = styled.input`
  display: flex;
  cursor: pointer;
  height: 15px;
  width: 15px;
`;

export default function CouponList({ coupons, setSelected }) {
  const [selectedCoupons, setSelectedCoupons] = useState([]);

  const onSelectAllClick = () => {
    // coupons.length !== selectedCoupons.length
    //   ? setSelectedCoupons(coupons)
    //   : setSelectedCoupons([]);

    if (coupons.length !== selectedCoupons.length) {
      setSelectedCoupons(coupons);
    } else {
      setSelectedCoupons([]);
    }
  };

  const onSelectClick = (selectedCoupon) => {
    if (selectedCoupons.includes(selectedCoupon)) {
      const updatedArray = selectedCoupons.filter(
        (item) => item !== selectedCoupon,
      );
      setSelectedCoupons(updatedArray);
    } else {
      setSelectedCoupons((selected) => [...selected, selectedCoupon]);
    }
  };

  useEffect(() => {
    function updateData() {
      setSelected(selectedCoupons);
    }
    updateData();
  }, [selectedCoupons, setSelected]);

  return (
    <Wrapper>
      <Heading>
        <HeadingText justify="flex-start">
          Total Available Discount:{' '}
          {`$${Price.output(
            coupons.reduce((total, item) => total + parseInt(item.amount), 0),
            true,
          )}`}
        </HeadingText>
        <HeadingText>
          Total Coupons Selected: {selectedCoupons.length}
        </HeadingText>
        <HeadingText justify="flex-end">
          Total Amount To Be Redeemed:
          {` $${Price.output(
            selectedCoupons.reduce(
              (total, item) => total + parseInt(item.amount),
              0,
            ),
            true,
          )}`}
        </HeadingText>
      </Heading>
      <TableContainer>
        <Row background={colors.grey6}>
          <Column justify="space-around">
            <HeaderText>#</HeaderText>
            <CheckBox
              type="checkbox"
              checked={coupons.length === selectedCoupons.length}
              onChange={() => onSelectAllClick()}
            />
          </Column>
          <Column>
            <HeaderText>AMOUNT</HeaderText>
          </Column>
          <Column>
            <HeaderText>EXPIRATION DATE</HeaderText>
          </Column>
        </Row>

        {coupons.map((coupon, index) => {
          const expirationTime = coupon.redemptionExpiration === 'Infinity' ? 'Does Not Expire' : moment(coupon.redemptionExpiration * 1000).format('MM-DD-YYYY');
          return (
            <Row
              key={index}
              background={selectedCoupons.includes(coupon) ? colors.grey6 : null}
            >
              <Column justify="space-around">
                <HeaderText>{index + 1}</HeaderText>
                <CheckBox
                  type="checkbox"
                  checked={selectedCoupons.includes(coupon)}
                  onChange={() => onSelectClick(coupon)}
                />
              </Column>
              <Column>
                <HeadText>{`$${Price.output(coupon.amount, true)}`}</HeadText>
              </Column>
              <Column>
                <HeadText>{expirationTime}</HeadText>
              </Column>
            </Row>
          );
        })}
      </TableContainer>
    </Wrapper>
  );
}
